import { useDialogStore } from "@shared/common/contexts/dialog/useDialogStore";
import { Dialog, DialogContentContainer, ScrollContainer } from "@shared/EDS/components/Dialog";
import { JSX, useId } from "react";
import { PrerequisiteItem } from "@shared/components/SidePanel/PrerequisiteItem";
import { TrainUnitTransitionsWrapper } from "./TrainUnitTransitionsWrapper";

export function TrainUnitTransitionsDialog(): JSX.Element {
  const trainUnitTransitionsDialogId = useId();
  const openDialog = useDialogStore((state) => state.openDialog);
  const closeDialog = useDialogStore((state) => state.closeDialog);

  return (
    <>
      <PrerequisiteItem
        title="Materieelovergangen"
        onClick={() => openDialog(trainUnitTransitionsDialogId)}
      />
      <Dialog dialogId={trainUnitTransitionsDialogId} title="Materieelovergangen" maxWidth="95svw">
        <DialogContentContainer>
          <ScrollContainer $height={"calc(85vh - 20px - (20px + 20px + 24px))"}>
            <TrainUnitTransitionsWrapper />
          </ScrollContainer>
          <div className="flex justify-end gap-xs px-l pt-l pb-0 [&>button]:px-5 [&>button]:py-xs">
            <tractie-button
              data-testid="train-unit-transitions-close-button"
              level="primary"
              onClick={() => closeDialog(trainUnitTransitionsDialogId)}
            >
              Sluiten
            </tractie-button>
          </div>
        </DialogContentContainer>
      </Dialog>
    </>
  );
}
